import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 3,
    },
  },
});

declare module '@tanstack/react-query' {
  interface Register {
    // Deliberately the common Error supertype rather than ApiError: a query
    // function can also throw a MoneyContractError or a mapper error, not only
    // a transport one. Consumers read backend messages via
    // getApiErrorMessages(), which narrows.
    defaultError: Error;
  }
}
